import * as actions from './actions';
import update from 'react/lib/update';

export const initState = {
	projects: [],
	isLoading: false,
	showFavorites: true
}

export default (state = initState, action) => {
	switch (action.type) {
		case actions.FETCH_PROJECTS_SUCCESS_INIT:
			return update(state, {
				projects: {
					$set: action.projects
				},
				isLoading: {
					$set: false
				}
			});
		case actions.FETCH_PROJECTS_SUCCESS:
			return update(state, {
				projects: {
					$push: action.projects
				},
				isLoading: {
					$set: false
				}
			});
		case actions.FETCH_PROJECTS_REQUEST:
			return update(state, {
				isLoading: {
					$set: true
				}
			});
		case actions.FETCH_PROJECTS_FAILURE:
			return update(state, {
				isLoading: {
					$set: false
				}
			});
		case actions.EDIT_CONTACT_REQUEST:
		case actions.EDIT_CONTACT_FAILURE:
			return update(state, {
				projects: {
					[action.projectIndex]: {
						contacts: {
							[action.contactIndex]: {
								$set: action.contact
							}
						}
					}
				}
			});
		case actions.CREATE_CONTACT_REQUEST:
			return update(state, {
				projects: {
					[action.projectIndex]: {
						contacts: {
							$splice: [[0, 0, action.contact]]
						}
					}
				}
			});
		case actions.CREATE_CONTACT_SUCCESS:
			return update(state, {
				projects: {
					[action.projectIndex]: {
						contacts: {
							0: {
								id: {
									$set: action.id
								}
							}
						}
					}
				}
			});
		case actions.CREATE_CONTACT_FAILURE:
			return update(state, {
				projects: {
					[action.projectIndex]: {
						contacts: {
							$splice: [[0, 1]]
						}
					}
				}
			});
		case actions.TOGGLE_FAVORITE:
			return update(state, {
				projects: {
					[action.projectIndex]: {
						favorite: {
							$set: action.favorite
						}
					}
				}
			});
		case actions.UPDATE_PROJECT_SUMMARY:
			return update(state, {
				projects: {
					[action.projectIndex]: {
						summary: {
							$set: action.summary
						}
					}
				}
			});

		case actions.SET_SHOW_FAVORITES:
			return update(state, {
				showFavorites: {
					$set: action.showFavorites
				}
			});

		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/App/Project/Dashboard/reducer.js